export default __webpack_public_path__ + "611b44ae71d25f24b36a9e84336846e4.png";